import axios from 'axios'
import { uuidv4 } from '/@/utils/uuid'
import { CURRENT_CONFIG } from './config'
import { message } from 'ant-design-vue'
import router from '/@/router'
import { ELocalStorageKey, ERouterName, EUserType } from '/@/types/enums'
export * from './type'

const REQUEST_ID = 'X-Request-Id'
function getAuthToken () {
  return localStorage.getItem(ELocalStorageKey.Token)
}

const instance = axios.create({
  // withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
  // timeout: 12000,
})

instance.interceptors.request.use(
  config => {
    config.headers[ELocalStorageKey.Token] = getAuthToken()
    // config.headers[REQUEST_ID] = uuidv4()
    config.baseURL = CURRENT_CONFIG.baseURL
    return config
  },
  error => {
    return Promise.reject(error)
  },
)

instance.interceptors.response.use(
  response => {
    return response
  },
  err => {
    if (!err.response || !err.response.status) {
      message.error('Backend inaccessible — vérifiez que le serveur est démarré.')
      return
    }
    if (err.response?.status === 401) {
      const flag: number = Number(localStorage.getItem(ELocalStorageKey.Flag))
      // Token expiré après plusieurs jours : on le supprime pour ne pas rester
      // coincé avec un token mort (sinon la page de login auto-redirige en boucle
      // vers une session déjà invalide).
      localStorage.removeItem(ELocalStorageKey.Token)
      localStorage.removeItem(ELocalStorageKey.WorkspaceId)
      switch (flag) {
        case EUserType.Web:
          router.push(ERouterName.PROJECT)
          break
        case EUserType.Pilot:
          router.push(ERouterName.PILOT)
          break
      }
    }
    return Promise.reject(err)
  },
)

export default instance
